<div class="card-body">
  @if (formGroup) {
    <patron-form [formGroup]="formGroup" (onSubmit)="onSubmit()">
      <div class="row">
        <div class="col-12 py-0">
          <patron-select
            [formGroup]="formGroup"
            formControlName="systems"
            modelName="realtime-systems"
            bindLabel="description"
            label="Selecione o Sistema">
          </patron-select>
        </div>
        <div class="row">
          <div class="col-md-6">
            <patron-select
              [formGroup]="formGroup"
              formControlName="platforms"
              label="Plataforma"
              [multiple]="true"
              placeholder="Selecione os campos"
              bindLabel="label"
              bindValue="value"
              [items]="platform_options">
            </patron-select>
          </div>
          <div class="col-md-6">
            <patron-switch
              [formGroup]="formGroup"
              formControlName="force_update"
              [trueValue]="1"
              [falseValue]="0"
              label="Forçar atualização">
            </patron-switch>
          </div>
        </div>
        <div class="col-12 py-0">
          <patron-form-field
            formControlName="title"
            [formGroup]="formGroup"
            label="Título"></patron-form-field>
        </div>
        <div class="col-12 py-0">
          <quill-editor
            formControlName="message"
            class="w-100"
            style="height: 300px"
            [required]="true"
            [modules]="modules"
            placeholder="Insira a mensagem aqui"></quill-editor>
        </div>
        <div class="col-12 py-0">
          <patron-select
            [formGroup]="formGroup"
            formControlName="receivers"
            placeholder="Selecione os destinatários"
            bindLabel="name"
            orderBy="name"
            label="Destinatários"
            modelName="bw-users"
            [multiple]="true"
            [findOptions]="receiversSelectFindOptions">
          </patron-select>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-auto">
          <patron-button
            type="submit"
            [loading]="loading"
            customStyle="width: 100%"
            class="w-full"
            iconName="bi-box-arrow-in-right">
            Enviar
          </patron-button>
        </div>
      </div>
    </patron-form>
  }
</div>
